// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2ah9h","modal":"Modal_modal__3g7l-"};